<template>
        <div class="" style="width: 100%;">
          <div class="task-modal-info" v-if="selectedTask && selectedTask.id">
            <div class="row">
              <div class="col text-center pt-3 pb-3" v-if="currentView != 'data_collection'">
                <div class="mb-3">
                  <strong>{{ $t('projects.create.task_assignees') }}</strong>
                </div>

                <span v-if="selectedTask.users && selectedTask.users.length">
                  <span class="mr-1 text-normal" v-for="(user, user_index) in getReducedUsers(selectedTask.users)"
                    :key="user_index">
                    <span qid="profile-photo">
                      <Avatar :object="user" size="xs"></Avatar>
                    </span>
                  </span>
                </span>
                <span v-if="selectedTask.users && selectedTask.users.length && selectedTask.users.length > 3"
                  class="badge cursor-pointer" @click="openUsersModal(selectedTask)">
                  <font-awesome-icon icon="users" />
                  + {{ selectedTask.users.length - 3 }}
                </span>
                <span class="assignee-add-btn"
                      v-if="!readOnly"
                      v-b-tooltip.hover
                      :title="$t('tasks.task_assignees.add')"
                      @click="showAddAssigneesModal('main')"
                      qid="task-modal-add-task-assignee"
                >
                  <font-awesome-icon icon="plus"/>
                </span>
              </div>
              <div class="col text-center pt-3 pb-3" v-if="currentView == 'data_collection'">
                <div class="mb-3">
                  <strong>{{ $t('tasks.table.data_collection_assignee') }}</strong>
                </div>
                <span v-if="selectedTask.data_users && selectedTask.data_users.length">
                  <span class="mr-1 text-normal" v-for="(user, user_index) in getReducedUsers(selectedTask.data_users)"
                    :key="user_index">
                    <span qid="profile-photo">
                      <Avatar :object="user" size="xs"></Avatar>
                    </span>
                  </span>
                </span>
                <span
                  v-if="selectedTask.data_users && selectedTask.data_users.length && selectedTask.data_users.length > 3"
                  class="badge cursor-pointer" @click="openUsersModal({ users: selectedTask.data_users })">
                  <font-awesome-icon icon="users" />
                  + {{ selectedTask.data_users.length - 3 }}
                </span>
                <span class="assignee-add-btn"
                      v-if="!readOnly"
                      v-b-tooltip.hover
                      :title="$t('tasks.data_collection_assignees.add')"
                      @click="showAddAssigneesModal('data_collection')"
                      qid="task-modal-add-data-collection-assignee"
                >
                  <font-awesome-icon icon="plus"/>
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('table.due_date') }}</strong>
                </div>
                <span class="text-normal" v-if="currentView != 'data_collection'">
                  <span v-if="getDifference(selectedTask.project.end_date) > 3">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-1" />
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span
                    v-if="getDifference(selectedTask.project.end_date) <= 3 && getDifference(selectedTask.project.end_date) >= 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span v-if="getDifference(selectedTask.project.end_date) < 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-12" />
                    {{ Math.abs(getDifference(selectedTask.project.end_date)) }}
                    {{ $t('system.days') }}
                    {{ $t('system.overdue') }}
                  </span>
                </span>
                <span class="text-normal" v-if="currentView == 'data_collection'">
                  <span v-if="getDifference(selectedTask.project.data_collection_end_date) > 3">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-1" />
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.data_collection_end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span
                    v-if="getDifference(selectedTask.project.data_collection_end_date) <= 3 && getDifference(selectedTask.project.data_collection_end_date) >= 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.data_collection_end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span v-if="getDifference(selectedTask.project.data_collection_end_date) < 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-12" />
                    {{ Math.abs(getDifference(selectedTask.project.data_collection_end_date)) }}
                    {{ $t('system.days') }}
                    {{ $t('system.overdue') }}
                  </span>
                  <span v-if="!selectedTask.project.data_collection_end_date">
                    {{ $t('system.n_a') }}
                  </span>
                </span>
              </div>
              <div class="col text-center pt-3 pb-3" v-if="currentView != 'data_collection'">
                <div class="mb-3">
                  <strong>{{ $t('system.task_status') }}</strong>
                </div>
                <span v-if="selectedTask.status === 'completed'">
                  <span class="text-normal" v-if="selectedTask.sign_off_count > 0">
                    <font-awesome-icon v-if="signOffReached" icon="check-circle" class="icon-success" />
                    <font-awesome-icon v-else icon="exclamation-triangle" class="sign-off-pending" />
                  </span>
                  <span class="text-normal" v-else-if="selectedTask.qa_status === 'rejected'">
                    <font-awesome-icon icon="times-circle" class="icon-danger" />
                  </span>
                  <span class="text-normal" v-else>
                    <font-awesome-icon icon="check-circle" class="icon-success" />
                  </span>

                </span>
                <span v-if="selectedTask.status === 'pending'" class="pr-1">
                  <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                </span>
                <span class="text-normal"
                  v-if="selectedTask.status === 'completed' && selectedTask.sign_off_count > 0">
                  {{ $t('system.signed_off') }} ({{ signOffProgress }})
                </span>
                <span class="text-normal"
                  v-else-if="selectedTask.status === 'completed' && selectedTask.qa_status === 'rejected'">
                  {{ $t('system.rejected') }}
                </span>
                <span class="text-normal" v-else-if="usesOeTesting && selectedTask.status === 'pending'" qid="task-modal-test-phase-status">
                  {{ $t('tasks.test_phase.status_' + (isInOeTesting ? 'operating_effectiveness' : 'design_implementation')) }}
                </span>
                <span class="text-normal" v-else>
                  {{ $t('system.' + $options.filters.slugify(selectedTask.status)) }}
                </span>
                <div v-if="selectedTask.status === 'completed' && selectedTask.signers && selectedTask.signers.length"
                  class="mt-2 text-normal" qid="task-modal-signers">
                  <div v-for="signer in selectedTask.signers" :key="signer.user_id">
                    {{ signer.name }} – {{ signer.signed_at | formatDateTime }}
                  </div>
                </div>
              </div>
              <div class="col text-center pt-3 pb-3" v-if="currentView == 'data_collection'">
                <div class="mb-3">
                  <strong>{{ $t('tasks.table.data_collection_status') }}</strong>
                </div>
                <!-- During OE testing the documentation collection follows the main task -->
                <span v-if="isInOeTesting && selectedTask.status !== 'completed'" qid="task-modal-data-status-oe">
                  <font-awesome-icon icon="exclamation-triangle" class="risk-6 pr-1" />
                  {{ $t('tasks.test_phase.status_operating_effectiveness') }}
                </span>
                <template v-else>
                  <span v-if="selectedTask.data_status && selectedTask.data_status === 'completed'">
                    <font-awesome-icon icon="check-circle" class="icon-success" />
                  </span>
                  <span v-if="selectedTask.data_status && selectedTask.data_status === 'pending'" class="pr-1">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                  </span>
                  <span v-if="selectedTask.data_status">
                    {{ $t('system.' + $options.filters.slugify(selectedTask.data_status)) }}
                  </span>
                  <span v-if="!selectedTask.data_status">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                    {{ $t('system.pending') }}
                  </span>
                </template>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('table.project') }}</strong>
                </div>
                <span v-if="isOwner(selectedTask.project)" class="text-success breadcrumb-item cursor-pointer"
                  @click="navigateToProject(selectedTask)">
                  <font-awesome-icon icon="calendar-alt" class="mr-1" />
                  {{ selectedTask.project.title }}
                </span>
                <span v-if="!isOwner(selectedTask.project)" class="text-success breadcrumb-item"
                  style="pointer-events:none;">
                  <font-awesome-icon icon="calendar-alt" class="mr-1" />
                  {{ selectedTask.project.title }}
                </span>
              </div>
              <!-- On the documentation collection the auditors are the main task assignees -->
              <div class="col text-center pt-3 pb-3" v-if="currentView == 'data_collection'">
                <div class="mb-3">
                  <strong>{{ $t('projects.create.task_assignees') }}</strong>
                </div>
                <span class="mr-1 text-normal" v-for="(user, user_index) in getReducedUsers(selectedTask.users || [])"
                  :key="user_index">
                  <span qid="profile-photo">
                    <Avatar :object="user" size="xs"></Avatar>
                  </span>
                </span>
                <span v-if="selectedTask.users && selectedTask.users.length > 3" class="badge cursor-pointer"
                  @click="openUsersModal(selectedTask)">
                  <font-awesome-icon icon="users" />
                  + {{ selectedTask.users.length - 3 }}
                </span>
                <span v-if="!selectedTask.users || !selectedTask.users.length" class="text-muted">
                  {{ $t('projects.engagement.filter.unassigned') }}
                </span>
              </div>
            </div>
          </div>
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">
              </div>
              <div class="col-sm-6 text-right">

                <b-modal ref="qa-log" :modal-class="v2ModalClass">
                  <template #modal-header="{ close }">
                    <div class="" style="width: 100%;">
                      <span @click="hideQaLog" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0 ">
                        <font-awesome-icon icon="times" />
                      </span>
                      <h5 class="mb-1 text-center" qid="update-user-title">
                        {{ $t('system.quality_control_log') }}
                      </h5>
                    </div>
                  </template>
                  <div class="pt-3" qid="qa-log-modal-body">
                    <div class="qa-log-summary">
                      <div>
                        <div class="qa-log-summary__label">{{ $t('system.current_sign_offs') }}</div>
                        <div class="qa-log-summary__value">
                          <font-awesome-icon v-if="signOffReached" icon="check-circle" class="icon-success mr-1" />
                          <font-awesome-icon v-else-if="selectedTask.sign_off_count > 0" icon="exclamation-triangle" class="sign-off-pending mr-1" />
                          {{ signOffProgress }}
                        </div>
                      </div>
                      <div>
                        <div class="qa-log-summary__label">{{ $t('system.required_sign_offs') }}</div>
                        <div class="qa-log-summary__value">{{ requiredSignOffs }}</div>
                      </div>
                    </div>
                    <QaLogTimeline v-if="qaComments && qaComments.length" :entries="qaComments"></QaLogTimeline>
                    <div v-if="!loadingQaComments && qaComments && !qaComments.length" class="text-muted">
                      {{ $t('system.no_results') }}
                    </div>
                    <div v-if="loadingQaComments">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                    </div>
                  </div>
                  <template #modal-footer="{ close }">
                    <div class="" style="width: 100%;">
                      <div class="alert alert-menu-color color-secondary mb-0" role="alert">
                        <div class="text-right">
                          <b-button class="" variant="secondary" @click="hideQaLog" qid="edit-p-cancel-button">
                            {{ $t('system.close') }}
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </template>
                </b-modal>

                <b-button class="ml-3 mt-2" variant="danger"
                  v-if="selectedTask.status == 'completed' && !projectLocked && selectedTask.can_sign_off !== false && selectedTask.qa_status != 'rejected' && selectedTask.code != 'system_impact_assessment' && currentView != 'data_collection'"
                  @click="showReopenQaTask" :disabled="buttonDisabled" qid="task-modal-save_without_complete-button">
                  {{ $t('system.reject_and_reopen') }}
                </b-button>
                <b-modal ref="reopen-qa-task" :modal-class="v2ModalClass">
                  <template #modal-header="{ close }">
                    <div class="" style="width: 100%;">
                      <span @click="hideReopenQaTask" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
                        <font-awesome-icon icon="times" />
                      </span>
                      <h5 class="mb-1 text-center" qid="update-user-title">
                        {{ $t('system.reject_and_reopen') }}
                      </h5>
                    </div>
                  </template>
                  <b-form @submit="reOpenQaTask" qid="create-framework-control-form">
                    <div class="form-container">
                      <b-form-group>
                        <label qid="create-framewor-control-pg-label">
                          {{ $t('system.rejection_comment') }}
                          <span class="text-red">*</span>
                        </label>
                      </b-form-group>
                      <b-form-textarea qid="create-q-data_collection-form-description" v-model="qa_comment" rows="6"
                        max-rows="6" required></b-form-textarea>
                    </div>
                  </b-form>
                  <template #modal-footer="{ close }">
                    <div class="" style="width: 100%;">
                      <div class="alert alert-menu-color color-secondary mb-0" role="alert">
                        <div class="text-right">
                          <b-button class="" variant="secondary" @click="hideReopenQaTask" qid="edit-p-cancel-button">
                            {{ $t('maintenance.measures.create.cancel') }}
                          </b-button>
                          <b-button class="ml-3" variant="danger" :disabled="buttonDisabled || qaCommentMissing" @click="reOpenQaTask()"
                            qid="edit-p-submit-button">
                            <span v-if="buttonDisabled" class="mr-1">
                              <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                            </span>
                            {{ $t('system.reject_and_reopen') }}
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </template>
                </b-modal>
                <b-modal ref="reopen-qa-task-complete" :modal-class="v2ModalClass">
                  <template #modal-header="{ close }">
                    <div class="" style="width: 100%;">
                      <span @click="hideReopenQaTask" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
                        <font-awesome-icon icon="times" />
                      </span>
                      <h5 class="mb-1 text-center" qid="update-user-title">
                        {{ $t('system.complete_rejected_task') }}
                      </h5>
                    </div>
                  </template>
                  <b-form @submit="reOpenQaTask" qid="create-framework-control-form">
                    <div class="form-container">
                      <b-form-group>
                        <label qid="create-framewor-control-pg-label">
                          {{ $t('system.completion_comment') }}
                          <span class="text-red">*</span>
                        </label>
                      </b-form-group>
                      <b-form-textarea qid="create-q-data_collection-form-description" v-model="qa_comment" rows="6"
                        max-rows="6" required></b-form-textarea>
                    </div>
                  </b-form>
                  <template #modal-footer="{ close }">
                    <div class="" style="width: 100%;">
                      <div class="alert alert-menu-color color-secondary mb-0" role="alert">
                        <div class="text-right">
                          <b-button class="" variant="secondary" @click="hideReopenQaTask" qid="edit-p-cancel-button">
                            {{ $t('maintenance.measures.create.cancel') }}
                          </b-button>
                          <b-button class="ml-3" variant="success" :disabled="buttonDisabled || qaCommentMissing"
                            @click="completeOpenQaTask()" qid="edit-p-submit-button">
                            <span v-if="buttonDisabled" class="mr-1">
                              <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                            </span>
                            {{ $t('tasks.modal.complete') }}
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </template>
                </b-modal>
                <b-button class="ml-3 mt-2" variant="success"
                  v-if="selectedTask.status == 'completed' && !projectLocked && selectedTask.can_sign_off !== false && !isCurrentSigner && selectedTask.code != 'system_impact_assessment' && currentView != 'data_collection'"
                  @click="acceptQaTask" :disabled="buttonDisabled" qid="task-modal-save_without_complete-button">
                  {{ $t('system.accept_and_complete') }}
                </b-button>


                <!-- Control assessment: fields save individually, so only Close and Finalize task -->
                <template v-if="isControlAssessment">
                  <b-button class="ml-3 mt-2" variant="secondary"
                    v-if="!readOnly && currentView != 'data_collection'"
                    @click="closeTask()" :disabled="buttonDisabled" qid="task-modal-close-button">
                    {{ $t('system.close') }}
                  </b-button>
                  <span class="d-inline-block" v-b-tooltip.hover
                    :title="finalizeBlockedReason"
                    v-if="!readOnly && currentView !== 'data_collection'">
                    <b-button class="ml-3 mt-2" variant="success"
                      @click="selectedTask.qa_status == 'rejected' ? showReopenQaTaskComplete() : finalizeTask()"
                      :disabled="buttonDisabled || !!finalizeBlockedReason"
                      :style="finalizeBlockedReason ? 'pointer-events: none;' : ''"
                      qid="task-modal-finalize_task-button">
                      {{ $t('tasks.modal.finalize_task') }}
                    </b-button>
                  </span>
                </template>

                <b-button class="ml-3 mt-2" variant="secondary"
                  v-if="!isControlAssessment && !readOnly && selectedTask.code != 'system_impact_assessment' && currentView != 'data_collection'"
                  @click="saveTask()" :disabled="buttonDisabled" qid="task-modal-save_without_complete-button">
                  {{ $t('system.save_without_complete') }}
                </b-button>
                <b-button class="ml-3 mt-2" variant="success" @click="completeTask()" :disabled="buttonDisabled"
                  qid="task-modal-complete_task-button"
                  v-if="!isControlAssessment && selectedTask.qa_status != 'rejected' && !readOnly && selectedTask.code !== 'system_impact_assessment' && currentView !== 'data_collection'">
                  {{ $t('tasks.modal.complete') }}
                </b-button>

                <b-button class="ml-3 mt-2" variant="success" @click="showReopenQaTaskComplete()"
                  :disabled="buttonDisabled" qid="task-modal-complete_task-button"
                  v-if="!isControlAssessment && selectedTask.qa_status == 'rejected' && !readOnly && selectedTask.code !== 'system_impact_assessment' && currentView !== 'data_collection'">
                  {{ $t('tasks.modal.complete') }}
                </b-button>

                <!--<b-button class="ml-3 mt-2"-->
                <!--variant="secondary"-->
                <!--v-if="selectedTask.status === 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView !== 'data_collection'"-->
                <!--@click="reOpenTask()"-->
                <!--:disabled="buttonDisabled"-->
                <!--qid="task-modal-cancel-button"-->
                <!--&gt;-->
                <!--{{ $t('tasks.modal.task_reopen_button') }}-->
                <!--</b-button>-->
                <!--<b-button class="ml-3 mt-2"-->
                <!--variant="success"-->
                <!--v-if="selectedTask.status === 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView !== 'data_collection'"-->
                <!--@click="saveTask()"-->
                <!--:disabled="buttonDisabled"-->
                <!--qid="task-modal-save-button"-->
                <!--&gt;-->
                <!--{{ $t('system.save') }}-->
                <!--</b-button>-->


                <b-button class="ml-3 mt-2" variant="secondary"
                  v-if="!readOnly && selectedTask.code !== 'system_impact_assessment' && currentView === 'data_collection'"
                  @click="saveDataTask()" :disabled="buttonDisabled" qid="task-modal-save_without_complete-button">
                  {{ $t('system.save_without_complete') }}
                </b-button>
                <b-button class="ml-3 mt-2" variant="success" @click="completeDataTask()" :disabled="buttonDisabled"
                  qid="task-modal-complete_data_task-button"
                  v-if="selectedTask.data_status !== 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView === 'data_collection'">
                  {{ $t('tasks.modal.complete') }}
                </b-button>

                <b-button class="ml-3 mt-2" variant="secondary"
                  v-if="selectedTask.data_status === 'completed' && !projectLocked && selectedTask.code !== 'system_impact_assessment' && currentView === 'data_collection'"
                  @click="reOpenDataTask()" :disabled="buttonDisabled" qid="task-modal-cancel-button">
                  {{ $t('tasks.modal.data_collection_reopen_button') }}
                </b-button>
                <b-button class="ml-3 mt-2" variant="success"
                  v-if="selectedTask.status === 'completed' && selectedTask.code !== 'system_impact_assessment' && currentView === 'data_collection'"
                  @click="saveTask()" :disabled="buttonDisabled" qid="task-modal-save-button">
                  {{ $t('system.save') }}
                </b-button>


                <b-button class="ml-3 mt-2" variant="secondary"
                  v-if="!readOnly && selectedTask.code == 'system_impact_assessment'"
                  @click="saveTask()" :disabled="buttonDisabled" qid="task-modal-save_without_complete-button">
                  {{ $t('system.save_without_complete') }}
                </b-button>
                <b-button class="ml-3 mt-2" variant="success"
                  v-if="!readOnly && selectedTask.code == 'system_impact_assessment'"
                  @click="completeSystemRiskTask()" :disabled="buttonDisabled"
                  qid="task-modal-complete_system_risk-button">
                  {{ $t('tasks.modal.complete') }}
                </b-button>

                <b-button class="ml-3 mt-2" variant="secondary"
                  v-if="selectedTask.status == 'completed' && !projectLocked && selectedTask.code == 'system_impact_assessment'"
                  @click="reOpenTask()" :disabled="buttonDisabled" qid="task-modal-cancel-button">
                  {{ $t('tasks.modal.task_reopen_button') }}
                </b-button>
                <b-button class="ml-3 mt-2" variant="success"
                  v-if="selectedTask.status == 'completed' && selectedTask.code == 'system_impact_assessment'"
                  @click="saveTask()" :disabled="buttonDisabled" qid="task-modal-save-button">
                  {{ $t('system.save') }}
                </b-button>
              </div>
            </div>
          </div>

          <!-- Add task assignees (engagement team) or documentation collection assignees (any user) -->
          <b-modal ref="add-data-users" :modal-class="v2ModalClass" @hide="addDataUsersError = ''">
            <template #modal-header>
              <div class="" style="width: 100%;">
                <span @click="$refs['add-data-users'].hide()" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
                  <font-awesome-icon icon="times" />
                </span>
                <h5 class="mb-1 text-center">{{ addAssigneesMode === 'main' ? $t('tasks.task_assignees.add') : $t('tasks.data_collection_assignees.add') }}</h5>
              </div>
            </template>
            <b-alert v-if="addDataUsersError.length" show variant="danger">{{ addDataUsersError }}</b-alert>
            <div class="multiselect-row">
              <multiselect v-model="newDataUsers"
                           :options="dataUserOptions"
                           :multiple="true"
                           :taggable="false"
                           :internal-search="false"
                           track-by="id"
                           label="name"
                           :select-label="$t('system.dropdown_select_label')"
                           :selected-label="$t('system.dropdown_selected_label')"
                           :deselect-label="$t('system.dropdown_deselect_label')"
                           :placeholder="addAssigneesMode === 'main' ? $t('projects.create.task_assignees') : $t('tasks.table.data_collection_assignee')"
                           @search-change="addAssigneesMode === 'main' ? null : loadDataUserOptions($event)"
                           qid="task-modal-add-data-users-select"
              >
                <template slot="tag" slot-scope="props">
                  <span class="mr-3 user-tag">
                    <Avatar :object="props.option" size="xs"></Avatar>
                    <span class="ml-2">{{ props.option.name }}</span>
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <UserDropdownOption :user="props.option"></UserDropdownOption>
                </template>
              </multiselect>
              <UserInviteModal v-if="addAssigneesMode !== 'main'" :buttonType="'small'" :buttonDisabled="addingDataUsers" @reloadUserList="loadDataUserOptions()"></UserInviteModal>
            </div>
            <template #modal-footer>
              <div class="" style="width: 100%;">
                <div class="alert alert-menu-color color-secondary mb-0" role="alert">
                  <div class="text-right">
                    <b-button variant="secondary" @click="$refs['add-data-users'].hide()">{{ $t('projects.create.cancel') }}</b-button>
                    <b-button class="ml-3" variant="success" :disabled="addingDataUsers || !newDataUsers.length" @click="submitDataUsers" qid="task-modal-add-data-users-submit">
                      {{ $t('projects.create.submit') }}
                    </b-button>
                  </div>
                </div>
              </div>
            </template>
          </b-modal>
        </div>
</template>

<script>
import assessmentSingleTaskProxy from './assessmentSingleTaskProxy';
import Avatar from '@/components/Avatar.vue';
import UserDropdownOption from '@/components/UserDropdownOption.vue';
import QaLogTimeline from '@/components/tasks/QaLogTimeline.vue';
import UserInviteModal from '@/components/user/UserInviteModal.vue';
import piincHttp from '@/util/configureAxios.js';

export default {
  name: 'AssessmentGlobalSingleTaskModalFooter',
  mixins: [assessmentSingleTaskProxy],
  components: {
    UserDropdownOption,
    Avatar,
    QaLogTimeline,
    UserInviteModal
  },
  data() {
    return {
      newDataUsers: [],
      dataUserCandidates: [],
      addAssigneesMode: 'data_collection',
      addingDataUsers: false,
      addDataUsersError: ''
    };
  },
  computed: {
    dataUserOptions() {
      if (this.addAssigneesMode === 'main') {
        // Main tasks can only be assigned to the engagement team (the project's users)
        const assignedIds = _.map(this.selectedTask.users || [], 'id');
        const team = (this.selectedTask.project && this.selectedTask.project.users) || [];
        return _.filter(team, user => !assignedIds.includes(user.id));
      }
      // Users already on the documentation collection can't be added again
      const existingIds = _.map(this.selectedTask.data_users || [], 'id');
      return _.filter(this.dataUserCandidates, user => !existingIds.includes(user.id));
    }
  },
  methods: {
    showAddAssigneesModal(mode) {
      this.addAssigneesMode = mode;
      this.newDataUsers = [];
      this.addDataUsersError = '';
      if (mode !== 'main') {
        this.loadDataUserOptions();
      }
      this.$refs['add-data-users'].show();
    },
    loadDataUserOptions(query) {
      let self = this;
      piincHttp.get('users', { params:
        {
          client: this.$store.state.client.id,
          keyword: query ? query : undefined,
          per_page: 100
        }
      }).then(function(response) {
        self.dataUserCandidates = response.data.items;
      }, function() {});
    },
    submitDataUsers() {
      let self = this;
      this.addingDataUsers = true;
      this.addDataUsersError = '';
      const add = this.addAssigneesMode === 'main' ? this.addTaskAssignees : this.addDataCollectionUsers;
      add(this.newDataUsers).then(function() {
        self.addingDataUsers = false;
        self.$refs['add-data-users'].hide();
      }, function(error) {
        self.addingDataUsers = false;
        self.addDataUsersError = error.data && error.data.message ? error.data.message : '';
      });
    }
  }
};
</script>
